import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCheckoutPage } from "../redux/Actions/AppActions";
import FormCheckout from "../components/FormCheckout";
import { Logo } from "../components/Logo";
import { CardButton } from "../components/CardButton";
import ProductCart from "../components/ProductCart";
import { countTaxFee, formatNumber, getDistanceKm, rateUsdt, tinhGiaShipSoKm } from "../service";
import { ORDER_CREATE_RESET } from "../redux/Constants/OrderConstants";
import { createOrder } from "../redux/Actions/OrderActions";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import Breadcrumb from "../components/Breadcrumb";
import { FaSpinner } from "react-icons/fa6";

export default function Checkout({ history }) {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(setCheckoutPage(true));
        return () => {
            dispatch(setCheckoutPage(false));
        };
    }, [dispatch]);
    const cart = useSelector((state) => state.cart);
    const [shippingAddress, setShippingAddress] = useState();
    const { cartItems } = cart;
    const userLogin = useSelector((state) => state.userLogin);
    const { userInfo } = userLogin;

    const [taxPrice, setTaxPrice] = useState(0);

    const addDecimals = (num) => (Math.round(num * 100) / 100).toFixed(2);

    cart.itemsPrice = addDecimals(
        cart.cartItems.reduce((acc, item) => acc + item.price * item.qty, 0)
    );

    cart.shippingPrice = 0;
    const total = cartItems.reduce((a, i) => a + i.qty * i.price, 0).toFixed(2);
    cart.taxPrice = taxPrice;

    cart.totalPrice = (
        Number(cart.itemsPrice) +
        Number(cart.shippingPrice) +
        (Number(cart.taxPrice))
    ).toFixed(2);

    const orderCreate = useSelector((state) => state.orderCreate);
    const { order, success, error, loading } = orderCreate;
    useEffect(() => {
        if (success) {
            history.push(`/order/${order._id}`);
            dispatch({ type: ORDER_CREATE_RESET });
        }
    }, [history, dispatch, success, order]);

    useEffect(() => {
        const fetchTax = async () => {
            try {
                console.log(cart.shippingAddress);

                // const km = await getDistanceKm(cart.shippingAddress.address.replace(cart.shippingAddress.saveData.address, ''));
                // const fee = await tinhGiaShipSoKm(km + 1.5);

                // console.log('fee', );
                let fee = await countTaxFee(cart.shippingAddress.saveData.provinceId, cart.shippingAddress.saveData.wardCode);

                if (shippingAddress?.paymentMethod == "cod") {
                    setTaxPrice(fee * 2 / (rateUsdt));
                } else {
                    setTaxPrice(fee / (rateUsdt));
                }
                // setTaxPrice(tf);

            } catch (err) {
                console.error(err);
                setTaxPrice(0);
            }
        };
        fetchTax();
    }, [cart]);
    const placeOrderHandler = () => {

        dispatch(
            createOrder({
                orderItems: cart.cartItems,
                shippingAddress: cart.shippingAddress,
                paymentMethod: cart.paymentMethod || shippingAddress.paymentMethod,
                itemsPrice: cart.itemsPrice,
                shippingPrice: cart.shippingPrice,
                taxPrice: cart.taxPrice,
                totalPrice: cart.totalPrice,
            })
        );
    };
    // const breadcrumbItems = [
    //     { label: "Trang chủ", href: "/" },
    //     { label: "Thanh toán", href: `/checkout` },
    // ];
    return (
        <>
            {/* <Breadcrumb items={breadcrumbItems} /> */}
            <div className="w-full  flex-col min-h-screen justify-center items-start bg-white grid grid-cols-2">
                <div className="col-span-2 flex flex-col items-center justify-center border-b h-[70px] md:h-[100px] p-4">
                    <div className="w-full lg:w-[1200px] flex justify-between items-center">
                        <Logo />
                        <CardButton />
                    </div>
                </div>
                {cartItems.length <= 0 && <div className="text-sm text-center p-16 col-span-2 flex flex-col justify-center items-center gap-4 ">
                    <p>Giỏ hàng trống</p>

                    <Link to="/" className="bg-[--color-button-3] w-auto px-6 py-2 rounded-full text-white text-sm font-bold 
                    hover:bg-[--color-button-2] hover:text-black transition-all duration-200 ">
                        <button>Tiếp tục mua sắm</button>
                    </Link>
                </div>}
                {cartItems.length > 0 && <>
                    <div className="col-span-2 md:col-span-1 flex flex-col items-end w-full h-full ">
                        <div className="w-full lg:w-[600px]">
                            <FormCheckout history={history} getData={setShippingAddress} onSubmit={placeOrderHandler} />
                            <div className="hidden md:block text-center text-sm text-gray-600 mt-6 space-x-4">
                                <a href="#">Chính sách hoàn tiền</a>
                                <a href="#">Vận chuyển</a>
                                <a href="#">Chính sách bảo mật</a>
                                <a href="#">Điều khoản dịch vụ</a>
                                <a href="#">Liên hệ</a>
                            </div>
                        </div>

                    </div>
                    <div className="col-span-2 md:col-span-1  bg-[--color-button-1] flex flex-col items-start w-full h-full ">
                        <div className="w-full lg:w-[600px] p-6  sticky top-0">
                            <h2 className="text-lg font-semibold mb-4">Tóm tắt đơn hàng</h2>
                            {cartItems && cartItems?.map((value, index) => {
                                console.log(value);

                                return <ProductCart key={index} product={value} isCheckOut={true} className={"!bg-transparent"} />
                            })}

                            <div className="border-t pt-2">
                                <div className="flex justify-between text-sm">
                                    <span>Tổng tiền</span>
                                    <div className="flex gap-2 text-[--color-button-3]">
                                        <img src="/images/logoToken.png" style={{ width: 20 }} /> {(Number(total)).toFixed(2)} <span className="text-black">({formatNumber(total * rateUsdt)}đ)</span>
                                    </div>
                                </div>
                                <div className="flex justify-between text-sm">
                                    <span>Shipping</span>
                                    <span>
                                        {!shippingAddress?.address && "Nhập địa chỉ"}
                                        {shippingAddress?.address && <div className="flex gap-2">
                                            {/* {shippingAddress.paymentMethod} */}
                                            <img src="/images/logoToken.png" style={{ width: 20 }} /> {
                                                shippingAddress.paymentMethod != 'cod'
                                                    ?
                                                    <>
                                                        <span style={{ textDecoration: 'line-through', fontSize: 15 }}>{((Number(cart.shippingPrice) + Number(cart.taxPrice) * 2)).toFixed(2)}</span> {((Number(cart.shippingPrice) + Number(cart.taxPrice))).toFixed(2)} <span className="text-black">({formatNumber((Number(cart.shippingPrice) + Number(cart.taxPrice)) * rateUsdt)}đ)</span>

                                                    </>
                                                    :
                                                    <>{(Number(cart.shippingPrice) + Number(cart.taxPrice)).toFixed(2)} <span className="text-black">({formatNumber((Number(cart.shippingPrice) + Number(cart.taxPrice)) * rateUsdt)}đ)</span> </>
                                            } </div>}
                                    </span>
                                </div>
                                <div className="flex justify-between font-semibold mt-2">
                                    <span>Tổng cộng</span>
                                    <div className="flex gap-2 text-[--color-button-3]">
                                        <img src="/images/logoToken.png" style={{ width: 20 }} /> {cart.totalPrice} <span className="text-black">({formatNumber(cart.totalPrice * rateUsdt)}đ)</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="flex md:hidden col-span-2 md:col-span-1  flex-col items-end w-full h-full p-4">
                        <button
                            type="submit"
                            form="checkoutForm"
                            className={`flex items-center justify-center gap-2  w-full bg-blue-600 text-white py-3 rounded font-semibold hover:bg-blue-700 ${loading ? "opacity-60" : ""}`}
                            disabled={loading}
                        >
                            ĐẶT HÀNG {loading && <FaSpinner className="animate-spin text-white" />}
                        </button>
                        <div className="hidden md:block text-center text-sm text-gray-600 mt-6 space-x-4">
                            <a href="#">Chính sách hoàn tiền</a>
                            <a href="#">Vận chuyển</a>
                            <a href="#">Chính sách bảo mật</a>
                            <a href="#">Điều khoản dịch vụ</a>
                            <a href="#">Liên hệ</a>
                        </div>

                    </div>
                </>}
            </div>
        </>
    );
}
